module.exports = __webpack_public_path__ + "static/media/Range.86a0e273.png";